import { useGET } from './useGET';

const toUrl = teamId => '/team/' + teamId;

export default function useTeam(teamId) {
  const url = toUrl(teamId);
  const team = useGET(url);

  return team;
}
